import { useEffect } from "react";
import socket from "./Socket";

export const useSocketConnection = () => {
    useEffect(() => {

        const ensureConnection = () => {
            if (!socket.connected) {
                socket.connect();
            }
        };

        ensureConnection();

        const handleDisconnect = () => {
            // attempt reconnect
            if (!socket.connected) {
                socket.connect();
            }
        };

        socket.on("disconnect", handleDisconnect);

        return () => {
            socket.off("disconnect", handleDisconnect);

            // optional: disconnect only if needed
            if (socket.connected) {
                socket.disconnect();
            }
        };

    }, []);
};